"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _reactRedux = require("react-redux");

var _ui = require("@alycecom/ui");

var _utils = require("@alycecom/utils");

var _commonData = require("../../../../Shared/store/commonData/commonData.selector");

var styles = {
  checkmark: {
    position: 'absolute',
    top: 0,
    right: 0,
    backgroundColor: 'green.mountainMeadow100',
    height: 24,
    width: 24,
    borderRadius: '50%',
    color: 'common.white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transform: 'translate(50%, -50%)'
  },
  root: {
    position: 'relative',
    backgroundColor: 'common.white',
    display: 'flex',
    flexDirection: 'column',
    boxShadow: 2,
    p: 0.5,
    border: function border(_ref) {
      var spacing = _ref.spacing;
      return "".concat(spacing(0.5), " solid transparent");
    }
  },
  selected: {
    borderColor: 'green.mountainMeadow100',
    borderRadius: 1
  },
  imageFigure: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 150,
    flex: '0 0 auto',
    '& > img': {
      height: 150
    }
  },
  countryFigure: {
    display: 'flex',
    alignItems: 'center',
    ml: 1,
    flex: '0 0 18px',
    '& > img': {
      width: '100%'
    }
  },
  fullProductName: {
    fontSize: '14px',
    lineHeight: '18px'
  },
  shortProductName: {
    fontSize: '14px',
    lineHeight: '18px',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden'
  },
  providerName: {
    fontSize: '12px',
    color: 'grey.main'
  },
  productPrice: {
    fontSize: '14px',
    lineHeight: '18px',
    fontWeight: 700,
    mt: 0.5
  }
};

var SelectableProductItem = function SelectableProductItem(_ref2) {
  var onClick = _ref2.onClick,
      _ref2$selected = _ref2.selected,
      selected = _ref2$selected === void 0 ? false : _ref2$selected,
      image = _ref2.image,
      price = _ref2.price,
      currencySign = _ref2.currencySign,
      name = _ref2.name,
      provider = _ref2.provider,
      countryId = _ref2.countryId,
      _ref2$sx = _ref2.sx,
      sx = _ref2$sx === void 0 ? [] : _ref2$sx,
      onImageLoaded = _ref2.onImageLoaded,
      _ref2$loading = _ref2.loading,
      loading = _ref2$loading === void 0 ? false : _ref2$loading,
      _ref2$fullText = _ref2.fullText,
      fullText = _ref2$fullText === void 0 ? false : _ref2$fullText,
      _ref2$rangeDenominati = _ref2.rangeDenomination,
      rangeDenomination = _ref2$rangeDenominati === void 0 ? undefined : _ref2$rangeDenominati,
      _ref2$isMultipleGiftC = _ref2.isMultipleGiftCardValuesEnabled,
      isMultipleGiftCardValuesEnabled = _ref2$isMultipleGiftC === void 0 ? false : _ref2$isMultipleGiftC,
      boxProps = (0, _objectWithoutProperties2.default)(_ref2, ["onClick", "selected", "image", "price", "currencySign", "name", "provider", "countryId", "sx", "onImageLoaded", "loading", "fullText", "rangeDenomination", "isMultipleGiftCardValuesEnabled"]);
  var country = (0, _reactRedux.useSelector)((0, _react.useMemo)(function () {
    return countryId ? (0, _commonData.makeGetCountryById)(countryId) : function () {
      return null;
    };
  }, [countryId]));
  return /*#__PURE__*/_react.default.createElement(_material.Box, (0, _extends2.default)({}, boxProps, {
    role: "button",
    onClick: onClick,
    sx: [styles.root, selected && styles.selected].concat((0, _toConsumableArray2.default)(Array.isArray(sx) ? sx : [sx]))
  }), selected && /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: styles.checkmark
  }, /*#__PURE__*/_react.default.createElement(_ui.Icon, {
    width: 12,
    icon: "check"
  })), /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: styles.imageFigure
  }, loading ? /*#__PURE__*/_react.default.createElement(_material.Skeleton, {
    variant: "rectangular",
    width: "100%",
    height: 130
  }) : /*#__PURE__*/_react.default.createElement(_ui.MarketplaceProductImage, {
    src: image !== null && image !== void 0 ? image : '',
    onLoad: onImageLoaded
  })), /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "flex",
    flexDirection: "column",
    flex: "1 1 auto",
    justifyContent: "space-between",
    overflow: "hidden",
    mt: 1.5
  }, loading && /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: styles.shortProductName
  }, /*#__PURE__*/_react.default.createElement(_material.Skeleton, {
    variant: "text",
    width: 125
  })), fullText && !loading ? /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: styles.fullProductName
  }, name) : /*#__PURE__*/_react.default.createElement(_ui.Tooltip, {
    placement: "top",
    arrow: true,
    title: name
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: styles.shortProductName
  }, name)), /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between"
  }, /*#__PURE__*/_react.default.createElement(_material.Box, null, provider && /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: styles.providerName
  }, provider), /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: styles.productPrice
  }, loading && /*#__PURE__*/_react.default.createElement(_material.Skeleton, {
    variant: "text",
    width: 50
  }), !loading && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !isMultipleGiftCardValuesEnabled || !rangeDenomination ? /*#__PURE__*/_react.default.createElement(_ui.NumberFormat, {
    format: "".concat(currencySign, "0,0.00")
  }, price) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_ui.NumberFormat, {
    format: "".concat(rangeDenomination === null || rangeDenomination === void 0 ? void 0 : rangeDenomination.currencySign, "0,0.00")
  }, rangeDenomination === null || rangeDenomination === void 0 ? void 0 : rangeDenomination.minPrice), "-", /*#__PURE__*/_react.default.createElement(_ui.NumberFormat, {
    format: "".concat(rangeDenomination === null || rangeDenomination === void 0 ? void 0 : rangeDenomination.currencySign, "0,0.00")
  }, rangeDenomination === null || rangeDenomination === void 0 ? void 0 : rangeDenomination.maxPrice))))), (country || loading) && /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: styles.countryFigure
  }, loading ? /*#__PURE__*/_react.default.createElement(_material.Skeleton, {
    variant: "circular",
    height: 24,
    width: 24
  }) : !!country && (0, _utils.isValidImage)(country.image) && /*#__PURE__*/_react.default.createElement("img", {
    src: country.image,
    alt: country.code
  })))));
};

var _default = SelectableProductItem;
exports.default = _default;